import GenerationModal from "./GenerationModal";

export default GenerationModal;